class NgContainer4 extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });

    const button = document.createElement("button");
    button.textContent = "클릭하세요!";
    button.style.padding = "10px";
    button.style.backgroundColor = "blue";
    button.style.color = "white";

    this.shadowRoot.appendChild(button);
  }
}

if (!customElements.get('nine-grid4')) {
  customElements.define("nine-grid4", NgContainer4);
}